import React from 'react';

import { Heading, Slide, Section, preloader } from 'spectacle-ppa';
import MissionReport from 'components/missionReport';

import balloonSlide from '../../baseSlides/balloonSlide';
import videoSlide from '../../baseSlides/videoSlide';

import ianArmsFolded from '../../images/characters/ian_arms_folded.png';
import ianHeadshotSmile from '../../images/characters/ian_headshot_smile.png';
import saraTwistHandsOutYay from '../../images/characters/sara_twist_hands_out_yay.png';
import saraSmile from '../../images/characters/sara_smile.png';
import ianSaraSide from '../../images/characters/ian_sara_side.png';
import ianSaraLeanQuestioning from '../../images/characters/ian_sara_lean_questioning.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_knowTheRisks.md';
import markdownFileLevel2 from './level2_makeAPlan.md';
import markdownFileLevel3 from './level3_getAKit.md';

import imgLevel0Start from '../../images/level-0_start.png';
import imgLevel1Start from '../../images/level-1_start.png';
import imgLevel2Start from '../../images/level-2_start.png';

const levels = {
  '0': { img: imgLevel0Start },
  '1': { md: new MarkdownScript(markdownFileLevel1), img: imgLevel1Start },
  '2': { md: new MarkdownScript(markdownFileLevel2), img: imgLevel2Start },
  '3': { md: new MarkdownScript(markdownFileLevel3) }
};

export function preloadMissionReport () {
  preloader([
    ianArmsFolded,
    ianHeadshotSmile,
    saraTwistHandsOutYay,
    saraSmile,
    ianSaraSide,
    ianSaraLeanQuestioning,
    imgLevel0Start,
    imgLevel1Start,
    imgLevel2Start
  ]);
}

function missionReportSection ({ level, regionData }) {
  const md = levels[level].md;
  const missionReportQuestions = md.getQuestions('Questions', 'Content', regionData);
  return (
    <Section id="mission-report">

      {/* Intro video in level 3 */}
      { (level === 3) &&
        videoSlide({
          id: 'intro-video',
          notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
        })
      }

      {/* Scoring level 1 & 3 */}
      { (level === 1 || level === 3) &&
        balloonSlide({
          id: 'scoring',
          characterSide: 'left',
          characterImage: saraTwistHandsOutYay,
          html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
        })
      }

      {/* Scoring level 2  */}
      { (level === 2) &&
        balloonSlide({
          id: 'scoring',
          characterSide: 'right',
          characterImage: saraSmile,
          html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
        })
      }

      {/* Instructions levels 1 & 3 */}
      { (level === 1 || level === 3) &&
        balloonSlide({
          id: 'instructions',
          characterSide: 'right',
          characterImage: ianHeadshotSmile,
          html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
        })
      }

      {/* Instructions level 2 */}
      { (level === 2) &&
        balloonSlide({
          id: 'instructions',
          characterSide: 'left',
          characterImage: ianArmsFolded,
          html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
        })
      }

      {/* Mission Reporting Screen */}
      <Slide
          id="report"
          bgColor="black"
          missionReportQuestions={missionReportQuestions}>
        <div
            className={'ui-slide mission-report-level-' + (level - 1)}>
          <header
              className="level-header">
            <figure className="level-header-thumb"><img src={levels[level - 1].img}/></figure>
            <Heading size={2}>
              Mission Report:<br/>
              {md.getSectionMetadata('Mission Report', 'Title')}
            </Heading>
          </header>
          <section
              className="mission-report-form">
            <MissionReport missionReportQuestions={missionReportQuestions} />
          </section>
        </div>
      </Slide>

      {/* Impact screen */}
      {balloonSlide({
        id: 'impact',
        characterSide: 'right',
        characterImage: ianSaraSide,
        html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
        notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
      })}

      {/* Class Discussion */}
      {balloonSlide({
        id: 'class-discussion',
        characterSide: 'left',
        characterImage: ianSaraLeanQuestioning,
        html: md.getSubSectionAsHtml('Class Discussion', 'Content', false, regionData),
        notes: md.getSubSectionAsHtml('Class Discussion', 'Notes', false, regionData)
      })}

    </Section>
  );
}

export default missionReportSection;



// WEBPACK FOOTER //
// ./programs/epsHybridIntermediates/sections/12_missionReport/missionReportSection.jsx